import {Routes} from '@angular/router';

export const adminRoutes: Routes = [
  {
    path: 'admin/dashboard',
    loadComponent: () => import('@admin/pages/dashboard/dashboard').then(m => m.Dashboard),
  }
];
